import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  LocalStorageKey,
  LocalStorageService
} from '@auto-editor/data-access-local-storage';
import { environment } from '@auto-editor/environment';
import { OauthInfo, PersonAuthDetailsDto } from '@auto-editor/shared/models';
import { Observable, tap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export abstract class AuthService {
  private localStorageKey = LocalStorageKey;

  constructor(
    private http: HttpClient,
    private localStorageService: LocalStorageService
  ) {}

  getBasicAuthHeaders() {
    const apiClientId = `${environment.apiClientId}:${environment.apiSecretKey}`;
    return new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      Authorization: 'Basic ' + btoa(apiClientId)
    });
  }

  getBearerAuthHeaders() {
    const oauthInfo = this.getOauthInfo();

    return new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: `Bearer ${oauthInfo?.access_token}`
    });
  }

  getOauthInfo(): OauthInfo | null {
    const rawOauthInfo = this.localStorageService.getData(
      this.localStorageKey.oauthInfo
    );
    if (!rawOauthInfo) return null;

    try {
      return JSON.parse(rawOauthInfo) as OauthInfo;
    } catch {
      return null;
    }
  }

  saveOauthInfo(oauthInfo: OauthInfo): void {
    const stampedOauthInfo: OauthInfo = {
      ...oauthInfo,
      expires_at: Date.now() + oauthInfo.expires_in * 1000
    };
    this.localStorageService.saveData(
      this.localStorageKey.oauthInfo,
      JSON.stringify(stampedOauthInfo)
    );
  }

  isAccessTokenExpired(skewMs = 10_000): boolean {
    const oauthInfo = this.getOauthInfo();
    if (!oauthInfo?.expires_at) return true;

    return Date.now() >= oauthInfo.expires_at - skewMs;
  }

  // login(payload: LoginDto, clientCredential = false): Observable<OauthInfo> {
  //   const headers = this.getBasicAuthHeaders();
  //   let body = 'grant_type=client_credentials';

  //   if (!clientCredential) {
  //     body = `username=${payload.username}&password=${encodeURIComponent(
  //       payload.password
  //     )}&grant_type=password`;
  //   }

  //   return this.http
  //     .post<OauthInfo>(environment.serverApi + '/oauth/token', body, {
  //       headers: headers
  //     })
  //     .pipe(
  //       tap((oauthInfo) => {
  //         if (!clientCredential) {
  //           this.localStorageService.saveData(
  //             this.localStorageKey.oauthInfo,
  //             JSON.stringify(oauthInfo)
  //           );
  //         }
  //       }),
  //       catchError((error: HttpErrorResponse) => {
  //         if (error.status === 400) {
  //           if (error.error.message[0] === 'email or password not valid') {
  //             return throwError({ signInError: true });
  //           }
  //         }
  //         return throwError(error);
  //       })
  //     );
  // }

  getUserLogged(): Observable<PersonAuthDetailsDto> {
    const headers = this.getBearerAuthHeaders();
    return this.http.get<PersonAuthDetailsDto>(
      `${environment.serverBackend}/person/me`,
      {
        headers: headers
      }
    );
  }

  // getUserById(userId: number): Observable<PersonDto> {
  //   const headers = this.getBearerAuthHeaders();
  //   return this.http.get<PersonDto>(
  //     environment.serverBackend + '/person/' + userId,
  //     {
  //       headers: headers
  //     }
  //   );
  // }

  logout(): Observable<string> {
    return this.http.post<string>(
      environment.serverApi + '/oauth/revoke',
      null
    );
  }

  getTokenByAuthorizationCode(
    code: string,
    urlRedirect: string
  ): Observable<OauthInfo> {
    const headers = this.getBasicAuthHeaders();
    const body = `code=${code}&grant_type=authorization_code&redirect_uri=${urlRedirect}`;
    return this.http
      .post<OauthInfo>(`${environment.serverBackend}/oauth/token`, body, {
        headers
      })
      .pipe(
        tap((oauthInfo) => {
          this.saveOauthInfo(oauthInfo);
        })
      );
  }
}
